import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { QuestionDetailModalComponent } from 'src/app/components/modals/question-detail-modal/question-detail-modal.component';
import { ConfigService } from 'src/app/services/config.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { QuestionsService } from 'src/app/services/questions.service';
import { SearchService } from 'src/app/services/search.service';
import { DefaultService } from 'src/app/utils/api';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    standalone: false
})
export class FaqComponent implements OnInit, OnDestroy {
    onDestroy$ = new Subject<void>();
    popoverHelper: any = null;
    panelData: any = null;
    hasPanelData: boolean = false;
    searchSTR: any = {};
    SEARCHED: any = {};

    // Table
    tableHeads: any = [
        { name: 'Vraag', code: 'title', sortable: true, width: '65%' },
        { name: 'Status', code: 'isPublished', sortable: true, width: '20%' },
        { name: 'Aangemaakt op', code: 'createTS', sortable: true, width: '5%' },
        { name: 'Laatst gewijzigd', code: 'updateTS', sortable: true, width: '5%' },
        { name: 'Gewijzigd door', code: 'updateBy', sortable: true, width: '5%' },
        { name: '', code: 'actions' }
    ];

    tableSort: { code: string; dir: string } = { code: 'createTS', dir: 'desc' };

    questions: any[] = null;
    startRow: number = 0;
    RPP: number = 50;
    totalRows: number = null;
    tableLoading: boolean = false;
    ready: boolean = false;

    constructor(
        private ModalService: NgbModal,
        private QuestionsService: QuestionsService,
        public HelpersService: HelpersService,
        public route: ActivatedRoute,
        public router: Router,
        private SearchService: SearchService,
        public ConfigService: ConfigService,
        private DefaultService: DefaultService
    ) {}

    ngOnInit(): void {
        this.initSearchSTR();
        const questionId = this.HelpersService.getParam('questionId');
        if (questionId) this.openCreateUpdateModal(questionId);
        const page = parseInt(this.HelpersService.getParam('page'));
        if (page) this.startRow = this.RPP * page - this.RPP;
        const query = this.HelpersService.getParam('query');
        if (query) this.searchSTR.query = query;
        this.getQuestions();
    }

    getQuestions() {
        this.SearchService.formatTags({ ...this.searchSTR }, this.getDefaultSearch()).then((response) => {
            this.SEARCHED = response;
            const searchSTR = this.getSearchQuery();
            this.deSelectRows();
            this.tableLoading = true;
            this.DefaultService.questionsGetQuestions(
                searchSTR.startRow,
                searchSTR.rRP,
                searchSTR.term,
                searchSTR.orderBy
            )
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((next) => {
                    if (this.startRow && this.startRow >= next.rows) {
                        this.resetStartRow();
                        return;
                    }
                    this.questions = next.data.map((item: any) => {
                        return this.getFormattedItem(item);
                    });
                    this.totalRows = next.rows;
                    this.tableLoading = false;
                    this.ready = true;
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                });
        });
    }

    getFormattedItem(item) {
        const actions = [
            {
                name: 'Wijzigen',
                code: 'edit',
                icon: 'pencil'
            },
            {
                name: 'Verwijderen',
                code: 'delete',
                icon: 'trash',
                class: 'delete-red',
                confirmDelete: true
            }
        ];
        let published = item.isPublished > 1 ? 'Niet gepubliceerd' : 'Gepubliceerd';
        let titleClassName = 'text-color';
        return {
            ...item,
            title: {
                type: 'default',
                classList: titleClassName,
                value: item.title
            },
            actions: {
                type: 'actions',
                actions: actions
            },
            updateTS: {
                type: 'ts',
                ts: item.updateTS,
                format: 'DD-MM-YYYY '
            },
            createTS: {
                type: 'ts',
                ts: item.createTS,
                format: 'DD-MM-YYYY '
            },
            isPublished: published
        };
    }

    deleteQuestion(id) {
        this.dismissPopover();
        this.deSelectRows();
        this.QuestionsService.deleteQuestion(id).subscribe((next) => {
            this.getQuestions();
        });
    }

    dismissPopover() {
        setTimeout(() => {
            this.popoverHelper = null;
        }, 1);
    }

    resetStartRow() {
        this.startRow = 0;
        this.HelpersService.addParam('page', (Math.ceil(this.startRow / this.RPP) + 1).toString());
        this.getQuestions();
    }

    changeStartRow(startRow: number) {
        this.startRow = startRow;
        this.HelpersService.addParam('page', (Math.ceil(this.startRow / this.RPP) + 1).toString());
        this.getQuestions();
    }

    getDefaultSearch() {
        return {
            questions: []
        };
    }

    getSortARR() {
        if (!this.tableSort || !this.tableSort.code) {
            return [];
        }
        return [`${this.tableSort.code} ${this.tableSort.dir}`];
    }

    setSort(code: string, dir: string) {
        this.tableLoading = true;
        this.tableSort = { code: code, dir: dir };
        this.getQuestions();
    }

    tableClick(item: any, head: string) {
        switch (item.type) {
            case 'actions':
                break;
            default:
                this.hasPanelData ? this.selectRow(item) : this.openCreateUpdateModal(item.id);
                break;
        }
    }

    actionClick(item: any, action: string) {
        switch (action) {
            case 'edit':
                this.openCreateUpdateModal(item.id, true);
                break;
            case 'delete':
                this.deleteQuestion(item.id);
                break;
        }
    } //todo

    selectRow(item: any) {
        this.questions = this.questions.map((x) => {
            if (x.id === item.id && !x.trActive) {
                x.trActive = true;
                this.panelData = item;
            } else if (x.id === item.id) {
                delete this.panelData;
                delete x.trActive;
            } else {
                delete x.trActive;
            }
            return x;
        });
    }

    search = (reset?: boolean, SEARCH?: any) => {
        SEARCH = SEARCH || this.searchSTR;
        this.searchSTR = { ...SEARCH };
        this.startRow = 0;
        if (reset) {
            this.initSearchSTR();
        }
        if (this.HelpersService.objectIsEmpty(SEARCH)) {
            this.HelpersService.removeParam('query');
        } else {
            const query = escape(JSON.stringify(SEARCH));
            this.HelpersService.addParam('query', query);
        }
        setTimeout(() => {
            this.HelpersService.addParam('page', (Math.ceil(this.startRow / this.RPP) + 1).toString());
        }, 1);
        this.getQuestions();
    };

    getSearchQuery() {
        return {
            ...this.searchSTR,
            startRow: this.startRow,
            rRP: this.RPP,
            orderBy: this.getSortARR()
        };
    }

    deSelectRows() {
        if (this.questions) {
            this.questions = this.questions.map((x) => {
                delete x.trActive;
                return x;
            });
        }
        delete this.panelData;
    }

    openCreateUpdateModal(id?: string, editMode?: boolean) {
        const modalRef = this.ModalService.open(QuestionDetailModalComponent, {
            windowClass: 'main-modal detail-modal',
            beforeDismiss: () => {
                return modalRef.componentInstance.canExit && modalRef.componentInstance.canExit();
            }
        });
        if (id) {
            this.HelpersService.addParam('questionId', id);
            //add pathparam to url
            modalRef.componentInstance.id = id;
            modalRef.componentInstance.editMode = editMode;
        } else this.HelpersService.addParam('questionId', 'new');
        modalRef.result
            .then((returnValue) => {
                switch (returnValue) {
                    case 'delete':
                        this.deSelectRows();
                        this.getQuestions();
                        break;
                }
            })
            .finally(() => {
                this.HelpersService.removeParam('questionId');
            });
        // on create
        modalRef.componentInstance.created.subscribe((tip: any) => {
            this.HelpersService.addParam('questionId', tip.id);
            this.search(true);
        });
        // on update
        modalRef.componentInstance.updated.subscribe((tip: any) => {
            this.getQuestions();
        });
    }

    initSearchSTR(): void {
        this.searchSTR = {};
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
}
